window.block_fun_keys =	function(e) {
	if (e.ctrlKey && e.key.toLowerCase() === 'f') {
		e.preventDefault();
	}

	if (event.key === 'F1' || event.key === 'F2' || event.key === 'F3' || event.key === 'F4'|| event.key === 'F5'|| event.key === 'F6'|| event.key === 'F7'|| event.key === 'F8'|| event.key === 'F9'|| event.key === 'F10'|| event.key === 'F11') {
		event.preventDefault(); // Prevent default browser actio
	}
};

$(function() {
	$("#block_fun_keys").on("click",function(){
		document.addEventListener('keydown', block_fun_keys);
		alert("SPECIAL KEYS DISABLES");
	});
});

$(function() {
  const scan_areas = document.getElementsByClassName("custom_tab");
  
  Array.from(scan_areas).forEach(function(scan_area) {
	  scan_area.addEventListener("keydown", function(e) {
	    if (e.key === "Tab") {
	      e.preventDefault();
	
	      const start 	= this.selectionStart;
	      const end 	= this.selectionEnd;
	
	      // Set textarea value to: text before caret + tab + text after caret
	      this.value = this.value.substring(0, start) + "\t" + this.value.substring(end);
	
	      // Move the caret
	      this.selectionStart = this.selectionEnd = start + 1;
	    }
	  });
	});
});


$(function() {
	$("#keydown_event_listner").on("click",function(){
		document.addEventListener('keydown', keydown_event_listner);
		alert("KEY DOWN EVEN ACTIVE");
	});
});

window.keydown_event_listner =	function(event) {
	console.log(`Key pressed: ${event.key} (Code: ${event.code})`);
};
